import { SET_VIEW } from 'actions/view'

const initialState = window.location.pathname.includes('/admin') ? 'admin' : 'user'

export default function set_view(state = initialState, action) {
  let newState = state
  switch (action.type) {
  case SET_VIEW:
    newState = action.payload
  }
  return newState
}
